var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("clearance.response.title")) + " ")]), _vm.value.subTotal ? _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.$t("clearance.response.subtitleSubtotal", {
    amount: _vm.formatCurrency(_vm.value.subTotal, _vm.value.currency)
  })) + " ")]) : _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.$t("clearance.response.subtitle")) + " ")]), _c('v-card-text', [_c('line-items-form', {
    attrs: {
      "readonly": true,
      "showProducts": false,
      "showQuantity": false,
      "showTax": false
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1), _c('v-card-text', {
    staticClass: "d-flex"
  }, [_vm.value.repairStart ? _c('v-chip', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v(" mdi-calendar-start ")]), _c('span', {
    staticClass: "mr-1"
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.clearance.repairStart")) + " ")]), _vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(_vm.value.repairStart)) + " ")], 1) : _vm._e(), _vm.value.repairEnd ? _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v(" mdi-calendar-end ")]), _c('span', {
    staticClass: "mr-1"
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.clearance.repairEnd")) + " ")]), _vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(_vm.value.repairEnd)) + " ")], 1) : _vm._e()], 1), !_vm.value.repairStart || !_vm.value.repairEnd ? _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "info",
      "elevation": 0
    },
    on: {
      "click": function click($event) {
        _vm.showConfirmDialog = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("clearance.response.reply")) + " ")])], 1) : _vm._e()], 1), _vm.value.history && _vm.value.history.length > 0 ? _c('clearance-response-card-history', {
    attrs: {
      "value": _vm.value
    }
  }) : _vm._e(), _vm.showConfirmDialog ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.showConfirmDialog,
      "title": _vm.$t('clearance.response.confirmTitle'),
      "leftBtnText": _vm.$t('cancel'),
      "rightBtnText": _vm.$t('confirm'),
      "rightColor": 'primary',
      "loading": _vm.loading,
      "rightLoading": _vm.loading,
      "rightDisabled": !_vm.isValid || _vm.dto.repairStart === _vm.value.repairStart && _vm.dto.repairEnd === _vm.value.repairEnd,
      "supressKeyboardActions": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.showConfirmDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.showConfirmDialog = $event;
      },
      "close": function close($event) {
        _vm.showConfirmDialog = false;
      },
      "leftClick": function leftClick($event) {
        _vm.showConfirmDialog = false;
      },
      "rightClick": _vm.confirmClearanceResponse
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.clearance.repairStart'),
      "hint": _vm.$t('objects.clearance.repairStartHint'),
      "readonly": _vm.value.repairStart,
      "type": "date",
      "persistent-hint": "",
      "outlined": "",
      "clearable": !_vm.value.repairStart,
      "prepend-inner-icon": "mdi-calendar-start"
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.dto.repairStart = null;
      }
    },
    model: {
      value: _vm.dto.repairStartFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.dto, "repairStartFormable", $$v);
      },
      expression: "dto.repairStartFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.endDateRules,
      "label": _vm.$t('objects.clearance.repairEnd'),
      "hint": _vm.$t('objects.clearance.repairEndHint'),
      "readonly": _vm.value.repairEnd,
      "type": "date",
      "persistent-hint": "",
      "outlined": "",
      "clearable": !_vm.value.repairEnd,
      "prepend-inner-icon": "mdi-calendar-end"
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.dto.repairEnd = null;
      }
    },
    model: {
      value: _vm.dto.repairEndFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.dto, "repairEndFormable", $$v);
      },
      expression: "dto.repairEndFormable"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }